import { defineStore } from 'pinia';
import { useApi } from '@/lib/api';
import { useGlobalStore } from '@/store/global-store-base';
import { useBrandUsers } from '@/store/brand-users';
import type { RoleDto, UserDto } from '@/ApiClient';

export const useRoles = defineStore('roles', () => {
  const api = useApi();
  const base = useGlobalStore({
    load: api.role_GetRoles,
    dto: 'RoleDto',
    create: api.role_AddRole,
    update: api.role_UpdateRole,
    delete: api.role_DeleteRole,
    usage: api.role_CountUsages,
    signalR: 'RoleUpdate',
  });

  const { loaded } = base;

  const getById = (id: number): RoleDto | undefined => loaded.value.find((r) => r.id === id);

  const usersForRole = (id: number): UserDto[] => useBrandUsers().loaded.filter((u) => u.roleIds?.includes(id));

  return {
    ...base,
    loaded,
    getById,
    usersForRole,
  };
});
